import { useMemo } from "react";
import { ConnectionName } from "@arelia-types/connection";
import useRequiredConnections from "@arelia-utils/helpers/useRequiredConnections";
import InteractionsPresenter from "./InteractionsPresenter";
import { useChartInteractions } from "../../api/social";
import { useChartDataArtistFilter } from "@arelia-hooks/artistAccount";
import { combineChartDataAndSum } from "@arelia-utils/helpers/chartsData";

export default function InteractionsContainer() {
  const requiredConnectionNames = [ConnectionName.youtube, ConnectionName.facebook, ConnectionName.tiktok];
  const hasRequiredConnections = useRequiredConnections(requiredConnectionNames);

  const { data = [], isLoading, isError } = useChartInteractions({ enabled: hasRequiredConnections });
  const filteredData = useChartDataArtistFilter(data);

  const chartData = useMemo(() => {
    const { labels, data } = combineChartDataAndSum(filteredData);
    return labels.map((label, i) => ({ label, value: data[i] }));
  }, [filteredData]);

  const getTooltip = (arg: { dataIndex: number }[]) => {
    return filteredData.map(({ networkName, data }) => `${networkName} ${data[arg[0].dataIndex]}`).join("\n");
  }

  return (
    <InteractionsPresenter
      chartData={chartData}
      getTooltip={getTooltip}
      loading={isLoading}
      error={isError}
      unconnected={!hasRequiredConnections}
    />
  );
}
